<template>
  <div>
    <section class="page-offset grid-side-content container mb-7">
      <div class="max-lg:contents">
        <h2 class="heading lg:pb-14">
          {{ $t('Fresh Produce Centre') }}
        </h2>
        <ContactInfo
          class="max-lg:pt-13 max-lg:order-last"
        />
      </div>
      <ContactParking :text="currentPage.template.text ?? currentPage.template.standard_text" />
    </section>

    <div class="my-20 lg:bg-sand">
      <section class="page-offset grid-side-content container mb-7 py-10">
        <div class="max-lg:contents">
          <h2 class="heading">
            {{ $t('Contact') }}
          </h2>
          <p class="text-black max-lg:order-last max-lg:pt-10">
            {{ $t('Contact help') }}
          </p>
        </div>
        <ContactForm />
      </section>
    </div>

    <section class="page-offset grid-side-content container mb-7">
      <div class="max-lg:contents">
        <h2 class="heading">
          {{ $t('Faq') }}
        </h2>
        <p class="text-black max-lg:order-last max-lg:pt-10">
          {{ $t('Faq description') }}
        </p>
      </div>
      <ContactFaq />
    </section>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  auth: false,
  middleware: ['sofie-page'],
});

const currentPage = useSofiePage();
</script>
